import {Injectable, OnDestroy} from '@angular/core';
import {EventInput, DateRangeInput, DatesSetArg} from '@fullcalendar/core';
import {ProjectActivity} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity';
import {
  ProjectActivityService
} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import {environment} from 'projects/desktop/src/environments/environment';
import {Subscription, timer, merge, Subject, Observable} from 'rxjs';
import {CalendarEventsStore} from './calendar-events.store';
import {CalendarEventsQuery} from './calendar-events.query';
import {AppStateQuery} from '../../../data/app-state.query';
import {takeUntil} from 'rxjs/operators';
import moment from 'moment';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';

// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
@Injectable()
@RxJSUnsubscribe
export class CalendarEventsService implements OnDestroy, RxJSUnsubscribable {

  eventsMap = new Map<string, ProjectActivity>();
  eventsElsMap = new Map<string, HTMLElement[]>();
  activityUserMap = new Map<number, Map<number, ProjectActivity>>();

  syncedSubj = new Subject<void>();

  eventLoadingSubs: Subscription;

  protected loadingEventsSubj = new Subject<boolean>();

  constructor(
    protected projectActivityService: ProjectActivityService,
    protected calendarEventsStore: CalendarEventsStore,
    protected calendarEventsQuery: CalendarEventsQuery,
    protected appStateQuery: AppStateQuery
  ) {
  }


  get loadingEvents$(): Observable<boolean> {
    return this.loadingEventsSubj
  }

  loadEventsForCalendar(dateRange: DateRangeInput) {
    this.calendarEventsStore.setLoading(true)

    if (this.eventLoadingSubs) {
      this.eventLoadingSubs.unsubscribe();
      this.eventLoadingSubs = null;
    }
    this.loadingEventsSubj.next(true);

    const typeIds = this.calendarEventsQuery.getValue().ui.typeIds;
    const userIds = this.calendarEventsQuery.getValue().ui.userIds;

    const convertToDate = (dateInput: any): Date => {
      if (dateInput instanceof Date) return dateInput;
      if (Array.isArray(dateInput)) return new Date(dateInput[0], dateInput[1], dateInput[2]);
      return new Date(dateInput);
    };

    const startDate = convertToDate(dateRange.start);
    const endDate = convertToDate(dateRange.end);

    this.eventLoadingSubs = this.projectActivityService
      .getActivityProjects(startDate, endDate, typeIds.length > 0 ? typeIds : undefined, userIds.length > 0 ? userIds : undefined)
      .subscribe(projectEvents => {
        const events = [];
        const today = moment().startOf('day');

        this.eventsMap.clear();
        this.activityUserMap.clear();

        projectEvents.forEach(projectActivity => {
          const userId = projectActivity.user?.id || 0;
          const eventId = `${projectActivity.id}-${userId}`;

          this.eventsMap.set(eventId, projectActivity);

          if (!this.activityUserMap.has(projectActivity.id)) {
            this.activityUserMap.set(projectActivity.id, new Map());
          }
          this.activityUserMap.get(projectActivity.id).set(userId, projectActivity);

          const tempClassNames = [`activity-type-${projectActivity.type.name}`, `ready-${projectActivity.ready}`];

          if (projectActivity.isSample) {
            tempClassNames.push('sample-activity')
          }

          if (!projectActivity.ready && today.isAfter(projectActivity.endDate)) {
            tempClassNames.push('late')
          }

          if (projectActivity.project.type && (projectActivity.type.name === 'JobDelivery' || projectActivity.type.name === 'PunchListDue')) {
            if (projectActivity.project.type.name === 'InHouseFinishing' || projectActivity.project.type.name === 'OrderFinishing') {
              tempClassNames.push('painted-activity')
            }
          }

          if (projectActivity.project.type && (projectActivity.type.name === 'JobDelivery' || projectActivity.type.name === 'ClientPickup')) {
            if (!projectActivity.project.salesListReady) {
              tempClassNames.push('sales-undone')
            }
          }

          if (projectActivity.deliveryInstructions) {
            tempClassNames.push('has-delivery-instructions')
          }

          const endDatePlusOne = moment(projectActivity.endDate).add(1, 'day').toDate();

          const eventData = {
            id: eventId,
            title: projectActivity.project.name,
            start: projectActivity.startDate,
            end: endDatePlusOne,
            allDay: true,
            classNames: tempClassNames,
            activityType: projectActivity.type.name,
            deliveryInstructions: projectActivity.deliveryInstructions,
            extendedProps: {
              activityId: projectActivity.id,
              userId
            }
          } as EventInput

          eventData.backgroundColor = '#' + projectActivity.type.color + '!important';

          events.push(eventData)
        })
        this.calendarEventsStore.set(events)
        this.loadingEventsSubj.next(false)
      })

  }

  updateDateRange(info: DatesSetArg) {
    this.calendarEventsStore.updateDateRange(info.view.activeStart, info.view.activeEnd)
  }

  ngOnDestroy() {

  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }
}
